module.exports = __webpack_public_path__ + "img/business-step.520211b9.png";